import '@mantine/core/styles.css'
import '@mantine/charts/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/dropzone/styles.css'
import '@mantine/notifications/styles.css'
import { createRoot } from 'react-dom/client'
import { App, router } from './frontend/App'

const elem = document.getElementById('root')!
const app = <App />

// Hapus splash hanya SETELAH router resolve route pertama — supaya tidak ada
// flash konten optimistic (mis. dashboard desa muncul sebelum redirect ke /platform).
let splashRemoved = false
function removeSplash() {
  if (splashRemoved) return
  splashRemoved = true
  const splash = document.getElementById('splash')
  if (!splash) return
  splash.classList.add('hide')
  setTimeout(() => splash.remove(), 300)
}

function scheduleSplashRemoval() {
  // Tunggu router siap (beforeLoad/loader selesai) baru hide splash.
  router
    .load()
    .catch(() => {})
    .finally(() => {
      // Satu frame supaya React sempat commit hasil render pertama.
      requestAnimationFrame(() => removeSplash())
    })
  // Safety net — kalau router.load() menggantung > 5s, paksa hide.
  setTimeout(removeSplash, 5000)
}

// HMR-safe rendering — reuse root agar state preserved saat hot reload
if (import.meta.hot) {
  import.meta.hot.data.root ??= createRoot(elem)
  const root = import.meta.hot.data.root
  root.render(app)
  scheduleSplashRemoval()
} else {
  createRoot(elem).render(app)
  scheduleSplashRemoval()
}
